import axios from "axios";

const baseurl = "https://api2.packky.com";
const username = "packky@gmail.com";
const password = "Z90LTO34RTNQGT49LCIYRVTXJERZTKX8";

const token = btoa(`${username}:${password}`);

const axiosInstance = axios.create({
  baseURL: baseurl,
  headers: {
    Authorization: `Basic ${token}`,
    "Content-Type": "application/json",
  },
});

export default axiosInstance;
